import { render, staticRenderFns } from "./ReservationRequest-Agreements.vue?vue&type=template&id=3bb61fe8"
import script from "./ReservationRequest-Agreements.vue?vue&type=script&lang=js"
export * from "./ReservationRequest-Agreements.vue?vue&type=script&lang=js"
import style0 from "./ReservationRequest-Agreements.vue?vue&type=style&index=0&id=3bb61fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports